import { FormItem } from '../../../../../../commons/Form/Form.types';
import { DashboardIPConsultsCOMFiltersFormSchema } from './DashboardIPConsultsCOMFiltersForm.types';

export const dashboardIPConsultsCOMFiltersFormData: FormItem<DashboardIPConsultsCOMFiltersFormSchema>[][] =
  [
    // [
    //   {
    //     name: 'domains',
    //     placeholder: "Catégories d'activité de la consultation...",
    //     label: "Catégories d'activité",
    //     type: 'select',
    //     id: 'categories',
    //     options: [
    //       {
    //         value: '1',
    //         label: 'Travaux de bâtiment',
    //       },
    //       {
    //         value: '2',
    //         label: 'Travaux Publics',
    //       },
    //       {
    //         value: '3',
    //         label: 'Fournitures',
    //       },
    //       {
    //         value: '4',
    //         label: 'Services',
    //       },
    //     ],
    //   },
    // ],
    [
      {
        name: 'fieldsOfActivity',
        placeholder: "Domaine d'activité de la consultation...",
        label: "Domaine d'activité",
        type: 'select',
        id: 'field-of-activity',
      },
    ],
  ];
